<template>
    <div class="login-wrap">
        <div class="login-bg"></div>
        <div style="width:100%;height:100%;position:relative">
            <div style="width:100%;height:47px"></div>
            <div class="login-logo"></div>
            <div class="login-center">
                <div class="login-center-left">
                    <div class="login-center-left1">
                        <div class="login-center-left11">Welcome To Login</div>
                        <div class="login-center-left12">使教育过程成为一种艺术的事业</div>
                        <div class="login-center-left13"></div>
                        <div class="login-center-left14">赫尔巴特</div>
                    </div>
                </div>
                <div class="login-center-right">
                    <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
                        <div class="login-center-right1">
                            <div class="login-center-right11">用户登录</div>
                            <div class="login-center-right12"></div>
                            <FormItem prop="userName">
                                <Input prefix="ios-contact" ref="username" :disabled="loadding" v-model="form.userName"
                                    placeholder="请输入用户名">
                                </Input>
                            </FormItem>
                            <div>
                                <FormItem prop="password" style="margin-bottom: 40px">
                                    <Input prefix="ios-lock-outline" :disabled="loadding" type="password"
                                        v-model="form.password" placeholder="请输入密码" />
                                </FormItem>
                            </div>
                            <Button class="login-center-right15" v-on:click="handleSubmit" :loading="loading">
                                <span v-if="!loading">登录</span>
                                <span v-else>Loading...</span>
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Login } from "nr.os.js";
import nros_js from "nr.os.js";
import axios from "axios";
import qs from "qs";
import DOMPurify from 'dompurify';
export default {
    name: "LoginForm",
    props: {
        userNameRules: {
            type: Array,
            default: () => {
                return [{ required: true, message: "账号不能为空", trigger: "blur" }];
            },
        },
        passwordRules: {
            type: Array,
            default: () => {
                return [{ required: true, message: "密码不能为空", trigger: "blur" }];
            },
        },
    },
    data() {
        return {
            loadding: false,
            loading: false,
            form: {
                userName: "",
                password: "",
            },
        };
    },
    methods: {
        handleSubmit() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    if (window.osConfig.ossUrl) {
                        this.casLogin();
                    } else {
                        this.handleLogin();
                    }
                }
            });
        },
        handleLogin(data) {
            let _this = this;
            this.loadding = true;
            this.loading = true;
            let params = {
                username: this.form.userName,
                psw: this.form.password,
            };
            const nros = new nros_js();
            let $http = nros.getPlugin("http");
            nros.getPlugin("http").setBaseURL(nros.getPlugin("config").getConfig().baseUrl);
            class customLogin extends Login {
                // 修改 login 接口
                login(option) {
                    if (!(option.username && option.psw)) throw new Error("Illegal username or password");
                    // if(!option.phoneNumber) throw new Error('No phone number')

                    return nros
                        .getPlugin("http")
                        .post("/nvwa/login", {
                            username: option.username,
                            pwd: option.psw,
                            tenant: "__default_tenant__",
                            encrypted: false,
                        })
                        .then((res) => {
                            if (res.data.token) {
                                this.loading = false;
                                this.loadding = false;
                                localStorage.setItem("TGT", res.data.token);
                                localStorage.setItem("_token", res.data.token);
                                $http.setHeaders(nros.getPlugin("login").getHeader());
                                nros.getPlugin("login").store(nros.getPlugin("config").getConfig().storageMode);
                                nros.getPlugin("event").emit("loginSuccess");
                                _this.token = res.data.token;
                                _this.getLoginContext();
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            this.loadding = false;
                            this.$Message.error("账号密码错误");
                        });
                }

                // 自定义验证请求头 可以在所有位置生效
                getHeader() {
                    return {
                        "my-token": this.loginContext.token,
                        tel: this.loginContext.phone,
                        "any-thing-you-like": "Hello World",
                    };
                }

                // 自定义 store 过程
                store(...args) {
                    // 可以调用父类的默认逻辑
                    super.store(...args);
                    console.log("已存储会话");
                }
            }
            const p = new customLogin();
            p.login(params);
        },
        getLoginContext() {
            let _this = this;
            var config = {
                method: "get",
                url: window.osConfig.baseUrl + "/nvwa/getLoginContext",
                headers: {
                    Authorization: _this.token, //设置token 其中K名要和后端协调好
                },
            };
            axios(config)
                .then(function (response) {
                    if (response.status == 200) {
                        GMS.userContext = response.data.context;
                        _this.$router.push({ path: "/" });
                    }
                    GMS.vbus.$emit("logininfo", response.data.context);
                })
                .catch(function (error) {
                    _this.$Message.error("账号密码错误");
                });
        },
        casLogin() {
            let _this = this;
            _this.loading = true;
            _this.loadding = true;
            var data = qs.stringify({
                password: this.form.password,
                username: this.form.userName,
            });
            var config = {
                method: "post",
                url: `${window.osConfig.ossUrl}/cas/v1/tickets`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                data: data,
            };
            axios(config)
                .then(function (response) {
                    _this.loading = false;
                    _this.loadding = false;
                    localStorage.setItem("TGT", response.data);
                    _this.getCasSt(response.data);
                })
                .catch(function (error) {
                    _this.loadding = false;
                    _this.loading = false;
                    _this.$Message.error("账号密码错误");
                });
        },
        getCasSt(TGT) {
            let that = this;
            let url = window.osConfig.staticService;
            var config = {
                method: "post",
                url: `${window.osConfig.ossUrl}/cas/v1/tickets/${TGT}?service=${url}`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                data: {},
            };
            axios(config)
                .then(function (response) {
                    localStorage.setItem("casticket", response.data);
                    window.location.href = `${new URL(location.href).origin}?ticket=${
                        DOMPurify.sanitize(response.data)
                    }`;
                })
                .catch(function (error) {
                    that.loadding = false;
                    that.loading = false;
                    that.$Message.error("账号密码错误");
                });
        },

        usernameFocus() {
            setTimeout(() => {
                this.$refs.username.focus();
            }, 500);
        },
    },
    computed: {
        rules() {
            return {
                userName: this.userNameRules,
                password: this.passwordRules,
            };
        },
    },
    components: {},
};
</script>

<style lang="less" scoped>
.login-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
    input {
        height: 44px;
    }
    .ivu-input-prefix {
        top: 6px;
    }
    .login-bg {
        background: #fff none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-image: url("../../static/login/背景@2x.webp");
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: -1;
    }
    .login-logo {
        width: 336px;
        height: 46px;
        background: url("../../static/login/LOGO@2x.webp");
        background-size: 336px 46px;
        margin-left: 70px;
    }
    .login-center {
        width: 800px;
        height: 333px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -400px;
        margin-top: -166px;
        border-radius: 4px;
    }

    .login-center-left {
        float: left;
        width: 724px;
        height: inherit;
        background: rgba(255, 255, 255, 0.39);
        backdrop-filter: blur(10px);
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        .login-center-left1 {
            float: left;
            margin-top: 146px;
            margin-left: 87px;
        }

        .login-center-left11 {
            height: 65px;
            font-family: PingFangSC-S0pxibold;
            font-weight: 600;
            font-size: 46px;
            color: #424242;
            margin-bottom: 17px;
            line-height: 65px;
        }
        .login-center-left12 {
            height: 22px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #424242;
            line-height: 22px;
            margin-bottom: 17px;
        }
        .login-center-left13 {
            width: 24px;
            height: 1px;
            background: #979797;
            margin-bottom: 16px;
        }
        .login-center-left14 {
            height: 22px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #424242;
            line-height: 22px;
        }
        @media screen and (max-width: 1800px) {
            .login-center-left1 {
                margin-top: 92px;
                margin-left: 39px;
            }
            .login-center-left11 {
                height: 56px;
                font-family: PingFangSC-S0pxibold;
                font-weight: 600;
                font-size: 40px;
                color: #424242;
                margin-bottom: 17px;
                line-height: 56px;
            }
            .login-center-left12 {
                height: 20px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #424242;
                line-height: 20px;
            }
            .login-center-left14 {
                height: 20px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #424242;
                line-height: 20px;
            }
        }
        @media screen and (min-width: 1800px) {
            .login-center-left1 {
                margin-top: 146px;
                margin-left: 87px;
            }
            .login-center-left11 {
                height: 65px;
                font-family: PingFangSC-S0pxibold;
                font-weight: 600;
                font-size: 46px;
                color: #424242;
                margin-bottom: 17px;
                line-height: 65px;
            }
            .login-center-left12 {
                height: 22px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 16px;
                color: #424242;
                line-height: 22px;
                margin-bottom: 17px;
            }
            .login-center-left14 {
                height: 22px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 16px;
                color: #424242;
                line-height: 22px;
            }
        }
    }
    .login-center-right {
        float: left;
        width: 476px;
        height: inherit;
        background: #ffffff;
        border-radius: 0 4px 4px 0;
        .login-center-right1 {
            float: left;
            margin-left: 88px;
            margin-top: 93px;
            width: 300px;
        }
        .login-center-right11 {
            width: 72px;
            height: 25px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 18px;
            color: #015293;
            line-height: 25px;
            margin: 0 auto;
            margin-bottom: 20px;
        }
        .login-center-right12 {
            width: 20px;
            height: 3px;
            background: #015293;
            border-radius: 1.5px;
            margin: 0 auto;
            margin-bottom: 26px;
        }
        .login-center-right13 {
            height: 44px;
            background: #ffffff;
            border: 1px solid #015293;
            border-radius: 2px;
            margin-bottom: 24px;
        }
        .login-center-right14 {
            height: 44px;
            background: #ffffff;
            border: 1px solid #b8b8b8;
            border-radius: 2px;
            margin-bottom: 40px;
        }
        .login-center-right15 {
            width: 300px;
            height: 44px;
            background: #015293;
            border-radius: 22px;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 44px;
        }
        @media screen and (max-width: 1800px) {
            .login-center-right1 {
                margin-left: 38px;
                margin-top: 41px;
                width: 241px;
            }
            .login-center-right15 {
                width: 240px;
            }
            .login-center-right11 {
                margin-bottom: 16px;
            }
            .login-center-right12 {
                margin-bottom: 20px;
            }
            .login-center-right13 {
                margin-bottom: 16px;
            }
            .login-center-right14 {
                margin-bottom: 30px;
            }
        }
        @media screen and (min-width: 1800px) {
            .login-center-right1 {
                margin-left: 88px;
                margin-top: 93px;
                width: 300px;
            }
            .login-center-right11 {
                margin-bottom: 20px;
            }
            .login-center-right12 {
                margin-bottom: 26px;
            }
            .login-center-right13 {
                margin-bottom: 24px;
            }
            .login-center-right14 {
                margin-bottom: 40px;
            }
        }
    }
    .login-use-input-wrap {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #424242;
        text-align: left;
        line-height: 44px;
    }
    @media screen and (min-width: 1800px) {
        .login-center {
            width: 1200px;
            height: 500px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -600px;
            margin-top: -250px;
            border-radius: 4px;
        }
        .login-center-left {
            width: 724px;
        }
        .login-center-right {
            width: 476px;
        }
        .login-center-right15 {
            width: 300px;
        }
    }
    @media screen and (max-width: 1800px) {
        .login-center {
            width: 800px;
            height: 333px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -400px;
            margin-top: -166px;
            border-radius: 4px;
        }
        .login-center-left {
            width: 483px;
        }
        .login-center-right {
            width: 317px;
        }
        .login-center-right15 {
            width: 160px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue